import { render, staticRenderFns } from "./SidebarDeads.vue?vue&type=template&id=63e0d96e"
import script from "./SidebarDeads.vue?vue&type=script&lang=js"
export * from "./SidebarDeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports